import { LinkButton } from '../../components/button'
import PageTitle from '../../components/page-title'
import { useAuth } from '../../contexts/auth'
import { ROUTES } from '../../constants'
import Hero from '../../components/hero'
import { VIEWS } from '../auth/modals'

export default function HeroSection() {
  const [{ isAuthenticated }, { setAuthModal }] = useAuth()

  return (
    <div className='heroContainer'>
      <Hero desktopImageSrc='/images/heroes/about.jpg' opacity={1}>
        <div className='titleContainer flex flexDirectionColumn alignCenter'>
          <PageTitle>
            About privauto,
            <br />
            The Best Way to Buy or Sell a Vehicle
          </PageTitle>
          <LinkButton href={ROUTES.Search}>Search Vehicles</LinkButton>
          {!isAuthenticated && (
            <p>
              Don’t have an account?{' '}
              <button
                className='flatBtn signUp'
                onClick={() => setAuthModal({ open: true, view: VIEWS.Register })}
              >
                Sign up.
              </button>
            </p>
          )}
        </div>
      </Hero>

      <style jsx>{`
        .heroContainer {
          :global(.hero) {
            padding: 14.7rem 0 0;
          }
        }

        .titleContainer {
          margin: 0 auto;
          padding: 0 1.2rem;

          :global(.pageTitle) {
            text-align: center;
            color: var(--primary-bg-color);
          }

          :global(a) {
            margin: 1.8rem 0 1.5rem;
          }

          p {
            font-size: 1.8rem;
            color: var(--primary-bg-color);
          }

          .signUp {
            color: var(--primary-color);
          }
        }

        @media (max-width: 1024px) {
          .heroContainer {
            :global(.hero) {
              padding: 2.7rem 0 0;
            }
          }

          .titleContainer {
            :global(a) {
              margin: 1.8rem 0 1rem;
            }

            p {
              font-size: 1.4rem;
            }
          }
        }
      `}</style>
    </div>
  )
}
